// extracted by mini-css-extract-plugin
export default {"artistPills":"SpotlightDetailsModal_artistPills__GVF7z","content":"SpotlightDetailsModal_content__+tEtu","description":"SpotlightDetailsModal_description__p4HCe"};